import Cookie from 'sharedController/cookie';
import AlgoliaConfig from "controller/algolia/algoliaConfig";

/**
 * Singleton class. We can only ever have one instance of this class tracking click codes.
 */
let instance = null;
export default class AlgoliaSetCookie
{
    constructor() {
        if (! instance) {
            instance = this;
            // Destroy any cookie the user might have from a previous request.
            try {
                Cookie.destroy(this.cookieName);
            } catch (e) { }
            this.cookieName = (new AlgoliaConfig()).getTrackingCookieName();
        }
        return instance;
    }

    setCookie(clickCode) {
        let me = this;
        if (clickCode) {
            let date = new Date();
            // session time of 15 minutes
            date.setTime(date.getTime() + (60 * 60 * 1000) + (15 * 60 * 1000));
            Cookie.set(me.cookieName, clickCode, date.toGMTString(), "/", null, null);
        }
    }
}